module.exports = __webpack_public_path__ + "img/unclickcompany.e075fbd6.svg";